import { connect, useSelector } from 'react-redux'
import { useState } from 'react'
import { Tooltip, Button } from 'antd'
import GraphFilterPanel from './GraphFilterPanel'
import { useHotKeys } from 'Hooks'
import Feather from '@sysunite/react-feather'
import './GraphFilterButton.scss'
import { flatMapUnique } from 'Services/GraphFilterUtils'

const GraphFilterButton = (props) => {
  const { onChangeFilter } = props

  const [ isOpen, setIsOpen ] = useState(false)
  const [ isTooltipVisible, setTooltipVisible ] = useState(false)

  const filterActive = useSelector(({ graphFilter }) =>
    flatMapUnique(graphFilter.filteredNodes).length > 0 ||
    flatMapUnique(graphFilter.filteredRelations).length > 0
  )

  const iconType = isOpen ? 'x' : 'eye'
  const classNames = ['graph-filter']

  isOpen && classNames.push('is-open')

  useHotKeys([{
    sequence: 'esc',
    fn: () => setIsOpen(false),
    expr: isOpen,
    temporary: true,
    watchers: [isOpen]
  }, {
    sequence: 'i',
    fn: () => setIsOpen(true),
    watchers: []
  }])

  const open = () => {
    setIsOpen(!isOpen)
    setTooltipVisible(false)
  }

  return (
    <Tooltip
      visible={!isOpen && isTooltipVisible}
      placement="bottomLeft"
      trigger="hover"
      onVisibleChange={(visible) => !isOpen && setTooltipVisible(visible)}
      mouseEnterDelay={1}
      title="Filter relations or types in the graph."
    >
      <div
        onContextMenu={(e) => e.stopPropagation()}
        className={classNames.join(' ')}>
        <Button
          type='link'
          onClick={open}
          icon={<Feather size="1.5em" type={iconType} />}
          className={filterActive && 'active' }
        />
        { isOpen ? <GraphFilterPanel isVisible={isOpen} onChangeFilter={onChangeFilter} /> : null }
      </div>
    </Tooltip>
  )
}

export default connect(({ graphFilter: { filterActive }}) => ({ filterActive }))(GraphFilterButton)
